module.exports = __webpack_public_path__ + "static/monoTinkoff-ffa1347db14ba99d70568e9a08e1c7de.jpg";